import { createIcon } from './create-icon'

export const Globe = createIcon({
  displayName: 'Globe',
  paths: [
    'M512 128c-212.096 0-384 171.904-384 384s171.904 384 384 384c212.096 0 384-171.904 384-384s-171.904-384-384-384zM597.321 256v-30.255c123.251 36.798 213.346 151.197 213.346 286.255 0 81.203-32.572 154.94-85.333 208.828v-38.199c0-23.552-19.115-42.624-42.667-42.624h-65.109l-1.067-85.888c-0.299-23.339-19.285-42.112-42.667-42.112h-189.824v-85.338h42.654c23.595 0 42.667-25.472 42.667-56.875v-56.917c0-4.905-0.465-9.667-1.34-14.208h86.673c23.595 0 42.667-19.115 42.667-42.667zM469.333 725.333v82.295c-144.554-20.762-256-145.421-256-295.629 0-23.94 2.831-47.232 8.175-69.555l162.492 157.508v82.714c0 23.552 19.115 42.667 42.667 42.667h42.667z'
  ]
})
